import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { ref: "appRoot" }
const _hoisted_2 = {
  key: 0,
  class: "tw-absolute tw-top-0 tw-left-[90px] tw-z-700"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"sm:tw-hidden\">xs</div><div class=\"tw-hidden sm:tw-block md:tw-hidden\">sm</div><div class=\"tw-hidden md:tw-block lg:tw-hidden\">md</div><div class=\"tw-hidden lg:tw-block xl:tw-hidden\">lg</div><div class=\"tw-hidden xl:tw-block\">xl</div>", 5)
const _hoisted_8 = [
  _hoisted_3
]
const _hoisted_9 = { class: "sf-container" }
const _hoisted_10 = { class: "md:tw-flex md:tw-gap-4 lg:tw-gap-16" }
const _hoisted_11 = {
  key: 1,
  class: "md:tw-order-1 tw-grow"
}
const _hoisted_12 = { class: "tw-grid tw-grid-cols-2 md:tw-grid-cols-1" }
const _hoisted_13 = { class: "sf-modal-body" }
const _hoisted_14 = { class: "sf-modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLogin = _resolveComponent("HeaderLogin")!
  const _component_HeaderAlerts = _resolveComponent("HeaderAlerts")!
  const _component_HeaderLogo = _resolveComponent("HeaderLogo")!
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_SfFaq = _resolveComponent("SfFaq")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDev)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_HeaderLogin, { class: "md:tw-order-2 tw-grow-0 tw-mb-4" }),
        (_ctx.$currentUser.value)
          ? (_openBlock(), _createBlock(_component_HeaderAlerts, {
              key: 0,
              class: "md:tw-order-1 tw-grow"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_11))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_HeaderLogo),
      _createVNode(_component_MainMenu)
    ]),
    _createVNode(_component_ModalDialog, {
      show: _ctx.contactVisible,
      onClosed: _ctx.hideContact
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_ContactForm)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClosed"]),
    _createVNode(_component_ModalDialog, {
      show: _ctx.faqVisible,
      onClosed: _ctx.hideFaqs,
      size: "full"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_SfFaq)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClosed"])
  ], 512))
}